import React, { useEffect, useRef, useState } from "react";
import { useSelector } from 'react-redux'
import { AppState } from '../../../../../../stateManager/store';
import { ParentNode } from './ParentNode'

interface TreeViewVisibility {
  components: {
    [key: string]: boolean
  },
  canvas: boolean
}

export const TreeView = (props: any) => {
  const parentDiv = useRef<any>(null);
  const json = useSelector((state: AppState) => {
    const formJson = state.formJson
    const { isEnabled, assetId } = formJson.assetEditMode
    if (isEnabled) {
      return formJson.assets[assetId].json
    }
    return formJson
  });
  const selectedElementId = useSelector((state: AppState) => state.formJson.selectedElementId)

  const [visibility, setVisibility] = useState<TreeViewVisibility>({
    canvas: true,
    components: {}
  })
  
  const [inputText, setInputText] = useState("");

  let searchHandler = (e: { target: { value: string; }; }) => {
    const lowerCase = e?.target?.value?.toLowerCase();
    setInputText(lowerCase);
  };

  const handleToggleVisibility = (isCanvas: boolean, id: string, forceVisibility?: string) => {
    setVisibility(prevState => {
      const currentVisibility = prevState.components[id]
      return {
        canvas: forceVisibility === "open" ?  true : isCanvas ? !prevState.canvas : prevState.canvas,
        components: {
          ...prevState.components,
          [id]: forceVisibility === "open" ? true : currentVisibility === undefined || currentVisibility === true ? false : true
        }
      }
    })
  }

  const parentDivRef = useRef<HTMLDivElement | null>(null);
  const [scrollInfo, setScrollInfo] = useState({
    scrollLeft: 0,
    containerWidth: 0,
    scrollWidth: 0
  });

  const handleScroll = () => {
    if (parentDivRef.current) {
      const { scrollLeft, clientWidth, scrollWidth } = parentDivRef.current;
      setScrollInfo({
        scrollLeft,
        containerWidth: clientWidth,
        scrollWidth
      });
    }
  };

  useEffect(() => {
    const parentDiv = parentDivRef.current;
    if (parentDiv) {
      setScrollInfo({
        scrollLeft: parentDiv.scrollLeft,
        containerWidth: parentDiv.clientWidth,
        scrollWidth: parentDiv.scrollWidth
      });

      parentDiv.addEventListener("scroll", handleScroll);
      const resizeObserver = new ResizeObserver(() => {
        if (parentDiv) {
          setScrollInfo({
            scrollLeft: parentDiv.scrollLeft,
            containerWidth: parentDiv.clientWidth,
            scrollWidth: parentDiv.scrollWidth
          });
        }
      });

      resizeObserver.observe(parentDiv);
      return () => {
        parentDiv.removeEventListener("scroll", handleScroll);
        resizeObserver.disconnect();
      };
    }
  }, []);

  return (
    <div
      style={{
        color: "#282B31",
        fontSize: "11px",
        background: "#FCFCFC",
        padding: "10px 0px 0px 10px"
      }}
    >
      <div className="relative" style={{ paddingBottom: "5px", paddingRight: "10px" }}>
        <div
          className="flex absolute inset-y-2 left-2.5 items-center pointer-events-none"
          style={{ height: "28px", top: 0 }}
        >
          <svg
            aria-hidden="true"
            className="w-5 h-5 text-gray-500 dark:text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            ></path>
          </svg>
        </div>
        <input
          required
          type="search"
          autoComplete="off"
          placeholder="Search..."
          value={inputText}
          onChange={searchHandler}
          style={{ height: "28px", top: 0 }}
          className="block pl-11 w-full text-base text-gray-900 bg-white rounded-lg border border-gray-300 focus:outline-none dark:bg-white-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
        />
        <button
          className="flex outline-none absolute inset-y-2 right-4 items-center justify-center top hover:bg-gray-100 rounded-full cursor-pointer"
          style={{ width: "24px", height: "24px", top: 2 }}
          onClick={() => setInputText("")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-5 h-5 text-gray-500 dark:text-gray-400"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div ref={parentDivRef} style={{ height: "calc(100vh - 150px)", overflow: "auto", scrollBehavior: "smooth" }}>
      <ParentNode
        json={json}
        item={json}
        isCheckedIn={props.isCheckedIn}
        visibility={visibility}
        handleToggleVisibility={handleToggleVisibility}
        selectedElementId={selectedElementId}
        searchValue={inputText}
        scrollInfo={scrollInfo}
        parentWidth={scrollInfo.scrollWidth}
      />
      </div>
    </div>
  );
};
